const DeviceUtils = {
  UA() {
    return (this.isWin() && window.navigator.userAgent) || "";
  },
  isWin() {
    return typeof window !== "undefined";
  },
  isMiniProgram() {
    return this.UA() && navigator.userAgent.indexOf("miniprogram") > -1;
  },
  isAPP() {
    return this.isWin() && /n8Web/i.test(this.UA());
  },
  isIOS() {
    return this.isWin() && /iphone|ipad|ipod/i.test(this.UA());
  },
  isAndroid() {
    return this.isWin() && /android/i.test(this.UA());
  },
  isWeixin() {
    return this.isWin() && /MicroMessenger/i.test(this.UA());
  },
  isDingTalk() {
    return this.isWin() && /DingTalk/i.test(this.UA());
  },
  isSafari() {
    return this.isWin() && /Safari/i.test(this.UA());
  },
  isQQ() {
    return this.isWin() && /QQ\/([\d.]+)/i.test(this.UA());
  },
  isMobile() {
    return this.isWin() && /iPhone|iPad|iPod|Android|Windows Phone/.test(this.UA());
  },
  isPC() {
    return this.isWin() && !this.isMobile();
  },
  isH5() {
    return this.isWin() && !this.isAPP();
  },
  isWS() {
    return this.isWin() && !!window.WebSocket;
  },
  isWebView() {
    return this.isAPP() || this.isWeixin();
  },
  isUCBrowser() {
    return this.isWin() && /UCBrowser/i.test(this.UA());
  },
  // 判断mac系统(含iphone手机)
  isMac() {
    return /macintosh|mac os x/i.test(navigator.userAgent);
  },
  // 判断windows系统
  isWindows() {
    return /windows|win32/i.test(navigator.userAgent);
  },
};

export default DeviceUtils;
